import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=406c625e&"
import script from "./Importer.vue?vue&type=script&lang=js&"
export * from "./Importer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Importer.vue"
export default component.exports